import React, { useEffect, useRef } from 'react';
import { ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';

import Colors from '../constants/Colors';
import { useUserContext } from '../context/UserContext';
import { useGetUserEncouragement } from '../hooks/user/useGetUserEncouragement';
import { P } from './Typography';
import elementIDs from '../../elementIDs';

const StyledContainer = styled.View<{ showRewardPoints?: boolean }>`
  width: 100%;
  background-color: ${p => (p.showRewardPoints ? '#E7DCFF' : '#d3f3ff')};
  padding: 12px 15px 0 8px;
  flex-direction: row;
`;

const MessageContainer = styled.View`
  width: 100%;
  min-height: 45px;
  background-color: white;
  flex: 1;
  border-radius: 10px;
  padding: 13px;
  margin-bottom: 12px;
  align-items: center;
  align-self: center;
`;

const MessageArrowContainer = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: flex-end;
`;

const MessageArrow = styled.View`
  background-color: transparent;
  border-style: solid;
  border-top-width: 13px;
  border-bottom-width: 13px;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-width: 23px;
  border-left-color: white;
  right: -15px;
`;

const StyledAvatarContainer = styled.View`
  margin-left: 20px;
  height: 100%;
  width: 64px;
  align-self: center;
`;

const StyledAvatarView = styled.View`
  position: absolute;
  bottom: 0;
`;

const StyledAvatar = styled.Image`
  height: 65px;
  width: 65px;
`;

const StyledP = styled(P)`
  line-height: 22px;
`;

const StyledError = styled(P)`
  color: ${Colors.error};
`;

const EncouragementView: React.FC<{ showRewardPoints?: boolean }> = ({
  showRewardPoints
}) => {
  const mountRef = useRef(false);
  const { user } = useUserContext();
  const {
    encouragement,
    loadingEncouragement,
    loadingEncouragementError,
    getEncouragement
  } = useGetUserEncouragement(user?.id || 0);
  useEffect(() => {
    if (!showRewardPoints && user && !mountRef.current) {
      getEncouragement();
      mountRef.current = true;
    }
  }, [getEncouragement, user, showRewardPoints]);
  return (
    <StyledContainer showRewardPoints={showRewardPoints}>
      <MessageContainer>
        <MessageArrowContainer>
          <MessageArrow />
        </MessageArrowContainer>
        {showRewardPoints ? (
          <StyledP color='dark' testID={elementIDs.encouragementEmojiID}>
            You have {user?.rewardPoint?.toLocaleString() || 0} points.
          </StyledP>
        ) : encouragement ? (
          <StyledP testID={elementIDs.encouragementEmojiID} color='dark'>
            {encouragement.message}
          </StyledP>
        ) : loadingEncouragement ? (
          <ActivityIndicator />
        ) : loadingEncouragementError ? (
          <StyledError>{loadingEncouragementError.message}</StyledError>
        ) : (
          <></>
        )}
      </MessageContainer>
      <StyledAvatarContainer>
        <StyledAvatarView>
          <StyledAvatar source={require('../assets/icon-scientist.png')} />
        </StyledAvatarView>
      </StyledAvatarContainer>
    </StyledContainer>
  );
};

export default EncouragementView;
